import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import {
  AdminAnalyticsFilterInput,
  AdminAnalyticsReportFieldsFragment,
  GetAdminAnalyticsReportDocument,
  GetAdminAnalyticsReportQuery,
  GetAdminAnalyticsReportQueryVariables
} from '~/api/graphql';

export const getAdminAnalyticsReport = async (filter?: AdminAnalyticsFilterInput) =>
  queryData<
    GetAdminAnalyticsReportQuery,
    GetAdminAnalyticsReportQueryVariables,
    AdminAnalyticsReportFieldsFragment
  >(
    client,
    { query: GetAdminAnalyticsReportDocument, variables: { filter }, fetchPolicy: 'network-only' },
    (data) => data?.adminAnalyticsReport
  );
